const CustomInput = ({label, value, name, placeholder, type = "text", className}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <label htmlFor={name} className="inline-block mb-1 text-sm text-[#8b8b8b] font-medium">{label}</label>
      <input id={name} type={type}  name={name} value={value} placeholder={placeholder} className="h-14 p-4 text-sm font-normal rounded-lg border-2 border-[#e7e7e7] transition-all duration-200 outline-transparent focus:outline-green-600 focus:outline-2 text-black"/>
    </div>
  );
};

export default CustomInput;
